import { Message } from 'element-ui'

const YMessage = Message

export default YMessage
